const getBaseStyles = () => ({
  container: {
    position: 'relative',
    width: '400px',
    maxWidth: '90%',
    height: '300px',
    perspective: '1000px',
    userSelect: 'none',
    touchAction: 'none',
    boxSizing: 'border-box',
    margin: '0 auto',
    transform: 'translateX(-5px)',
  },
  controls: {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '20px',
    color: '#666',
    fontSize: '14px',
    zIndex: 10,
    backgroundColor: 'rgba(255,255,255,0.9)',
    padding: '8px 16px',
    borderRadius: '20px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  },
  arrowKey: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px',
    borderRadius: '4px',
    fontWeight: 500,
  },
  arrow: {
    fontSize: '20px',
    color: '#444',
  },
  '@media (max-width: 600px)': {
    container: {
      height: '250px',
      width: '100%',
    },
  }
});

export const getCardStyles = (startX, offset, isVisible) => ({
  ...getBaseStyles(),
  card: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: '20px',
    boxSizing: 'border-box',
    cursor: 'grab',
    transition: startX === null ? 'all 0.5s ease-in-out' : 'none',
    transform: isVisible ? `translateX(${offset}px) rotate(${offset * 0.05}deg)` : 'translateX(-100vw) rotate(0deg)',
    opacity: isVisible ? 1 : 0,
    pointerEvents: isVisible ? 'auto' : 'none',
    backfaceVisibility: 'hidden',
    willChange: 'transform, opacity',
    display: isVisible ? 'block' : 'none',
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: '20px',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  word: {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontWeight: 'bold',
    color: '#2c3e50',
    textAlign: 'center',
    width: '90%',
    padding: '20px',
    letterSpacing: '0.02em',
    lineHeight: '1.4',
  },
  split: {
    position: 'absolute',
    bottom: 0,
    width: '50%',
    height: '40%',
    display: 'flex',
    alignItems: 'flex-end',
    padding: '16px',
    transition: 'opacity 0.3s',
  },
  leftSplit: {
    left: 0,
    background: 'linear-gradient(to right, rgba(245, 101, 101, 0.2), transparent)',
    justifyContent: 'flex-start',
    opacity: offset < 0 ? 1 : 0.5,
  },
  rightSplit: {
    right: 0,
    background: 'linear-gradient(to left, rgba(72, 187, 120, 0.2), transparent)',
    justifyContent: 'flex-end',
    opacity: offset > 0 ? 1 : 0.5,
  },
    meaning: {
      color: '#1a202c',
      maxWidth: '90%',
      textAlign: 'center',
      letterSpacing: '0.01em',
      lineHeight: '1.4',
      fontSize: '1.2em',
      fontWeight: '500',
    }
});
